/* ============================================================
   Yoganica theme — global JS
   ============================================================ */
(function () {
  'use strict';

  /* ---------- sticky header ---------- */
  var hdr = document.getElementById('hdr');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('stuck', window.scrollY > 12); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (e.isIntersecting) {
          e.target.style.transitionDelay = (i * 70) + 'ms';
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- announcement ticker (seamless loop) ---------- */
  var tick = document.getElementById('tick');
  if (tick && !tick.dataset.doubled) {
    tick.innerHTML += tick.innerHTML;
    tick.dataset.doubled = '1';
  }
  var mq = document.getElementById('mq');
  if (mq && !mq.dataset.doubled) {
    mq.innerHTML += mq.innerHTML;
    mq.dataset.doubled = '1';
  }

  /* ---------- toast ---------- */
  var toastEl = document.getElementById('toast');
  var toastMsg = document.getElementById('tmsg');
  var toastTimer;
  window.yoganicaToast = function (msg) {
    if (!toastEl || !toastMsg) return;
    toastMsg.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  };

  /* ---------- cart count badge ---------- */
  window.yoganicaSetCartCount = function (n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.remove('pop');
      void el.offsetWidth;
      el.classList.add('pop');
    });
  };

  /* ---------- refresh cart count from Shopify ---------- */
  window.yoganicaRefreshCart = function () {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.yoganicaSetCartCount(cart.item_count);
        return cart;
      })
      .catch(function () { /* silent */ });
  };

  /* ---------- AJAX add to cart ---------- */
  window.yoganicaAddToCart = function (variantId, qty, name) {
    var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); }); }
        return r.json();
      })
      .then(function () {
        window.yoganicaRefreshCart();
        window.yoganicaToast((name ? name : 'Item') + ' added to cart');
      })
      .catch(function (err) {
        window.yoganicaToast(err.message || 'Sorry, that could not be added');
      });
  };

  /* bind any [data-add-to-cart] buttons rendered by product cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    window.yoganicaAddToCart(id, 1, btn.getAttribute('data-product-title'))
      .then(function () { btn.disabled = false; });
  });

  /* ---------- mobile nav drawer ---------- */
  var burger = document.querySelector('.burger');
  var drawer = document.getElementById('drawer');
  var scrimNav = document.getElementById('scrimNav');
  var drawerClose = document.getElementById('drawerClose');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('on');
    if (scrimNav) scrimNav.classList.add('on');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('on');
    if (scrimNav) scrimNav.classList.remove('on');
    document.body.classList.remove('no-scroll');
  }
  if (burger) burger.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (scrimNav) scrimNav.addEventListener('click', closeDrawer);
  if (drawer) {
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeDrawer); });
  }

  /* ---------- predictive search overlay ---------- */
  var ov = document.getElementById('searchOv');
  var input = document.getElementById('searchInput');
  var results = document.getElementById('searchResults');
  var meta = document.getElementById('searchMeta');
  var searchClose = document.getElementById('searchClose');
  var searchOpen = document.querySelector('[data-search-open]');
  var searchTimer;

  function openSearch() {
    if (!ov) return;
    ov.classList.add('on');
    document.body.classList.add('no-scroll');
    setTimeout(function () { if (input) input.focus(); }, 250);
    if (meta) meta.textContent = 'Start typing, or pick a suggestion above.';
    if (results) results.innerHTML = '';
  }
  function closeSearch() {
    if (!ov) return;
    ov.classList.remove('on');
    document.body.classList.remove('no-scroll');
    if (input) input.value = '';
  }
  if (searchOpen) searchOpen.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (ov) ov.addEventListener('click', function (e) { if (e.target === ov) closeSearch(); });

  function money(cents) {
    try {
      return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
    } catch (e) { return '₹' + Math.round(cents / 100); }
  }

  function renderResults(items, q) {
    if (!results) return;
    var empty = document.getElementById('searchEmpty');
    if (empty) empty.remove();

    if (!items.length) {
      results.innerHTML = '';
      results.style.display = 'none';
      if (meta) {
        meta.textContent = 'No results for “' + q + '”';
        meta.insertAdjacentHTML('afterend',
          '<div class="search-empty" id="searchEmpty"><h4>No matches</h4>' +
          '<p>We couldn’t find that. Try “soup”, “tea” or “coffee”.</p></div>');
      }
      return;
    }
    results.style.display = 'grid';
    if (meta) meta.textContent = items.length + (items.length === 1 ? ' result' : ' results') + ' for “' + q + '”';
    results.innerHTML = items.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      return '<a class="sr" href="' + p.url + '">' +
        '<div class="srimg">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="srb">' +
        '<div class="srcat">' + (p.product_type || p.vendor || '') + '</div>' +
        '<div class="srn">' + p.title + '</div>' +
        '<div class="srp">' + (p.price != null ? money(p.price) : '') + '</div>' +
        '</div></a>';
    }).join('');
  }

  function doSearch(q) {
    q = (q || '').trim();
    if (!q) {
      if (results) results.innerHTML = '';
      if (meta) meta.textContent = 'Start typing, or pick a suggestion above.';
      var e = document.getElementById('searchEmpty'); if (e) e.remove();
      return;
    }
    var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(items, q);
      })
      .catch(function () {
        if (meta) meta.textContent = 'Search is unavailable right now.';
      });
  }

  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var v = input.value;
      searchTimer = setTimeout(function () { doSearch(v); }, 220);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
        window.location.href = root + 'search?q=' + encodeURIComponent(input.value);
      }
    });
  }
  document.querySelectorAll('#searchSuggest button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!input) return;
      input.value = btn.getAttribute('data-q');
      doSearch(input.value);
      input.focus();
    });
  });

  /* ---------- escape closes overlays ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    if (ov && ov.classList.contains('on')) closeSearch();
  });
})();
